// startup
// Load entry module and return exports
__webpack_modules__["./src/components/tab/tab.js"]();
__webpack_modules__["./src/components/tab/_tab.scss"]();
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["?6190"]();
